<p-table [value]="templateList"
        [lazy]="true" (onLazyLoad)="loadTemplateListByFilter($event)"
        [(first)]="first" [scrollable]="true"
        [totalRecords]="totalRecords"
        [rows]="pageSize" [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="tableShowMore">
    <ng-template pTemplate="header">
        <tr>
            <th>Template Name</th>
            <th>Channel Name</th>
            <th>Is Default</th>
            <th>Is Active</th>
            <th>Action</th>
            <th style="width: 4rem;max-width: 4rem;">
                <span class="btnBars" (click)="newTemplate()">
                    <i class="pi pi-plus" ></i>
                </span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-templateDetails>
        <tr>
            <td>{{templateDetails.templateName}}</td>
            <td>{{templateDetails.channelName}}</td>
            <td>
                {{templateDetails.isDefault ? 'Yes' :'No'}}
            </td>
            <td>
                {{templateDetails.statusId==1 ? 'Yes' :'No'}}
            </td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" (click)="editTemplate(templateDetails)"
                tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" pTooltip="View" (click)="viewTemplate(templateDetails)"
                tooltipPosition="top"><i class="pi pi-eye"></i></span>
                <span class="btnBars p-mr-0" pTooltip="Delete" (click)="deleteTemplate(templateDetails)"
                tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
            <td style="width: 4rem;max-width: 4rem;"></td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6">{{findOrLoadingText}}</td>
        </tr>
    </ng-template>
</p-table>

<app-email-template [display]="displayEmailTemplate" (dialogClose)="close()" (refreshList)="loadTemplateList()" [isView]="isView" [selectedEmailTemplate]="selectedEmailTemplate" [moduleId]="moduleId" [channelNames]="channelNames"></app-email-template>
<app-print-template [display]="displayPrintTemplate" (close)="close()" [templateTemp]="printTemp"></app-print-template>
